export const builtInReplacementMap = {
  _COMPANY_: '[COMPANY]',
  _GREETING_: 'Hello [FIRST_NAME]',
  _GREETING_W_TOD_: 'Good morning, [FIRST_NAME]',
  _AGENT_NAME_: '[AGENT_NAME]',
  _LEAD_LINK_: '[LEAD_LINK]',
  _REQUEST_CALL_: 'When is a good time for a call?',
  _LEAD_SOURCE_: '[LEAD_SOURCE]',
  _AGENT_PHONE_: '[AGENT_PHONE]',
  _GREET_W_TOD_: 'Good evening, [FIRST_NAME]',
  _TIME_OF_DAY_: 'afternoon',
};
